"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyMemoryBox = void 0;
exports.EmptyMemoryBox = {
    nucleusDataType: "memoryBox",
    media: []
};
